/* eslint-disable camelcase */
/* eslint-disable xss/no-mixed-html */
/* eslint-disable security/detect-object-injection */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@nextui-org/button";
import { Popover, PopoverContent, PopoverTrigger } from "@nextui-org/popover";
import { Tooltip } from "@nextui-org/tooltip";
import { Resizable } from "re-resizable";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { AppDispatch, RootState } from "../app/store";
import addFolder from "../assets/add_folder_icon.png";
import addFolderlight from "../assets/add_folder_icon_light.png";
import chatArrowIcon from "../assets/chat_arrow_icon.png";
import closeSidebar from "../assets/close_sidebar_icon.png";
import closeSidebarLight from "../assets/close_sidebar_icon_light.png";
import logo from "../assets/logo.png";
import newChat from "../assets/new_chat_icon.png";
import newChatlight from "../assets/new_chat_icon_light.png";
import openSidebar from "../assets/open_sidebar_icon.png";
import openSidebarLight from "../assets/open_sidebar_icon_light.png";
import searchIcon from "../assets/search_chat_icon.png";
import searchIconLight from "../assets/search_chat_icon_light.png";
import userChatIcon from "../assets/user_chat_icon.png";
import { logoutState } from "../features/auth/authSlice";
import { isNewChat, newChats, setActiveChat } from "../features/chatSlice";
import { fetchSidebar } from "../features/folderSlice";
import { closeModal, openModal } from "../features/modalSlice";
import { toggleMinimize } from "../features/themeSlice";
import { apiService } from "../services/apiService";
import { Chat, Folder, SidebarState } from "../types";
import { getCookieToken, removeCookieToken, UserData } from "../utils";
import OptionsMenu from "./OptionsMenu";
import SidebarSkeleton from "./SidebarSkeleton";

interface FormatChatProps {
  id: string; // Unique identifier for the chat
  title: string; // The title or content of the chat
  updated_at: string | Date; // Timestamp when the chat was last updated
  pinned: boolean; // Indicates whether the chat is pinned
  user?: string; // User associated with the chat (optional, since the function overrides it)
  [key: string]: any;
}
type ChatProps = {
  id: number;
  // Add other properties if necessary
};
type folderProps = {
  id: number;
  // Add other properties if necessary
};
// Define the type for user data

const Sidebar: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { chatID } = useParams(); // Access the dynamic 'id' from the URL, which may be undefined
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // Check if window width is less than 768px
      if (window.innerWidth < 768) {
        const sidebarElement = document.querySelector(".sidebar-container");
        if (sidebarElement && !sidebarElement.contains(event.target as Node)) {
          dispatch(toggleMinimize());
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dispatch]);

  // State variables with types
  const [selectedChatId, setSelectedChatId] = useState<number | null>(null);
  const [selectedFolderId, setSelectedFolderId] = useState<number | null>(null);
  const [isOptionsVisible, setIsOptionsVisible] = useState(false);
  const [isOptionsFolderVisible, setIsOptionsFolderVisible] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const [activeItem, setActiveItem] = useState<number | null>(null); // track active folder/chat
  const [activeFolder, setActiveFolder] = useState<number | null>(null); // track active folder/chat
  const [isFolderOpen, setIsFolderOpen] = useState<{ [key: number]: boolean }>({}); // Tracks which folders are open
  const isRenderSidebar = useSelector((state: RootState) => state.chat.isRenderSidebar);

  const [folders, setFolders] = useState<Folder[]>([]);
  const [chats, setChats] = useState<Chat[]>([]); // Ensure it's always an array
  const [isLoading, setIsLoading] = useState<boolean>(true); // Loading state
  const pinnedFolders = useSelector((state: RootState) => state.pin.pinned);
  const theme = useSelector((state: RootState) => state.theme.theme);
  const [userData, setUserData] = useState<UserData | null>(null);
  const [optionsPosition, setOptionsPosition] = useState<{
    left: number;
    top: number;
  }>({ left: 0, top: 0 });
  // Redux state
  const isMinimized = useSelector((state: { theme: SidebarState }) => state.theme.minimize);
  const isDarkMode = useSelector((state: { theme: SidebarState }) => state.theme.darkMode);
  const modals = useSelector(
    (state: { modal: { modals: Record<string, boolean> } }) => state.modal.modals
  );

  const { isOpen } = useSelector((state: RootState) => state.modal);

  const handleNewChat = () => {
    dispatch(newChats());
    setActiveItem(null);
    dispatch(isNewChat(true));
    navigate(`/chat`);
  };
  useEffect(() => {
    if (chatID) {
      const chatId = parseInt(chatID, 10); // Convert to number
      setSelectedChatId(chatId); // Highlight chat in the sidebar
      setActiveItem(chatId);
      dispatch(setActiveChat(chatID)); // Set active chat in Redux
    }
  }, [chatID, dispatch]);
  useEffect(() => {
    const data = getCookieToken("user");
    setUserData(data);
    const fetchData = async () => {
      setIsLoading(true); // Start loading
      try {
        // Fetch sidebar data via Redux thunk
        const response = await dispatch(fetchSidebar()).unwrap();

        const { folders = [], chats = [] } = response;
        const formatChat = (chat: FormatChatProps) => ({
          id: chat.id,
          user: "System", // Default user or replace as needed
          content: chat.title,
          timestamp: chat.updated_at,
          pinned: chat.pinned,
        });
        const formattedFolders = folders.map((folder: any) => ({
          id: folder.id,
          title: folder.folder_name,
          pinned: folder.pinned,
          messages: folder.chat_id?.map(formatChat)?.sort(
            (a: FormatChatProps, b: FormatChatProps) => (b.pinned ? 1 : 0) - (a.pinned ? 1 : 0)) || [], // Default to empty array
        }));
        // Set state with formatted data
        setFolders(formattedFolders); // Formatted folders with messages
        setChats(chats); // Separate chats
      } catch (error) {
        toast.error("Error fetching sidebar data", {
          className:
            "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
          duration: 2000,
        });
      } finally {
        setIsLoading(false); // Stop loading
      }
    };

    fetchData();
  }, [pinnedFolders, isOpen, isRenderSidebar]);

  // Helper function to get the icon based on dark/light mode
  const getIcon = (lightIcon: string, darkIcon: string) => (isDarkMode ? darkIcon : lightIcon);

  // Button configurations
  const sidetoolbarButtons = [
    {
      id: "search",
      icon: getIcon(searchIconLight, searchIcon),
      onClick: () => {
        if (window.innerWidth < 768) {
          dispatch(toggleMinimize());
        }
        handleToggleModal("ModalSearchChat");
      },
      alt: "search",
    },
    {
      id: "addFolder",
      icon: getIcon(addFolderlight, addFolder),
      // onClick: () => dispatch(openModal({ name: "ModalCreateFolder" })),
      onClick: () => {
        if (window.innerWidth < 768) {
          dispatch(toggleMinimize());
        }
        handleToggleModal("ModalCreateFolder");
      },
      alt: "add folder",
    },
    {
      id: "newChat",
      icon: getIcon(newChatlight, newChat),
      onClick: () => {
        if (window.innerWidth < 768) {
          dispatch(toggleMinimize());
        }

        handleNewChat();
      },
      alt: "new chat",
    },
  ];
  const toggleSidebar = () => {
    dispatch(toggleMinimize());
  };
  const isMobile = () => window.innerWidth <= 768;

  const handleChatSelect = (chat: ChatProps) => {
    setSelectedChatId(chat.id);
    setActiveItem(chat.id);
    dispatch(setActiveChat(chat.id.toString()));
    dispatch(isNewChat(false));
    navigate(`/chat/${chat.id || ""}`);
    if (isMobile()) {
      dispatch(toggleMinimize());
    }
  };
  const handleFolderSelect = (folder: folderProps) => {
    setSelectedFolderId(folder.id);
    setActiveFolder(folder.id);
    dispatch(setActiveChat("")); // Clear active chat
  };
  const handleToggleModal = (modalName: string) => {
    if (!Object.hasOwn(modals, modalName)) {
      // console.error("Modal name not found");
      return;
    }

    if (typeof modalName !== "string" || !/^\w+$/.test(modalName)) {
      // console.error("Invalid modal name");
      return;
    }

    // Close all open modals
    Object.keys(modals).forEach((key) => {
      if (modals[key]) {
        dispatch(closeModal(key));
      }
    });

    // Open the new modal if it's not already open
    if (!modals[modalName]) {
      dispatch(openModal({ name: modalName }));
    }
  };

  const handleDotFolderClick = (
    folderId: number,
    event: React.MouseEvent | React.KeyboardEvent
  ) => {
    dispatch(setActiveChat(folderId.toString()));
    // Prevent click event from propagating to the list item for mouse events
    if ("clientX" in event) {
      event.stopPropagation(); // For MouseEvent
    }

    const position =
      "clientX" in event ? { left: event.clientX, top: event.clientY } : { left: 0, top: 0 };

    // If it's a keyboard event, handle 'Enter' or 'Space' key presses
    if ("key" in event && (event.key === "Enter" || event.key === " ")) {
      // For keyboard events, prevent the default behavior if needed
      event.preventDefault();
      event.stopPropagation(); // Prevent further event bubbling
    }

    // Toggle or set the options based on selectedfolderId
    if (selectedFolderId !== null && selectedFolderId === folderId) {
      setIsOptionsFolderVisible(!isOptionsFolderVisible);
      dispatch(setActiveChat(folderId.toString()));
    } else {
      setSelectedFolderId(folderId);
      setActiveFolder(folderId);
      setIsOptionsFolderVisible(true);
    }

    setOptionsPosition(position);
  };

  const handleDotChatClick = (chatId: number, event: React.MouseEvent | React.KeyboardEvent) => {
    dispatch(setActiveChat(chatId.toString()));
    // Prevent click event from propagating to the list item for mouse events
    if ("clientX" in event) {
      event.stopPropagation(); // For MouseEvent
    }

    const position =
      "clientX" in event ? { left: event.clientX, top: event.clientY } : { left: 0, top: 0 };

    // If it's a keyboard event, handle 'Enter' or 'Space' key presses
    if ("key" in event && (event.key === "Enter" || event.key === " ")) {
      // For keyboard events, prevent the default behavior if needed
      event.preventDefault();
      event.stopPropagation(); // Prevent further event bubbling
    }

    // Toggle or set the options based on selectedfolderId
    if (selectedChatId !== null && selectedChatId === chatId) {
      setIsOptionsVisible(!isOptionsVisible);
      dispatch(setActiveChat(chatId.toString()));
      setIsOptionsFolderVisible(false);
    } else {
      setSelectedChatId(chatId);
      setIsOptionsVisible(true);
    }

    setOptionsPosition(position);
  };

  const handleOutsideClick = (event: MouseEvent) => {
    // Ensure event.target is an HTMLElement
    const target = event.target as HTMLElement | null;

    if (target && !target.closest(".chat-item") && !target.closest(".options-menu")) {
      setIsOptionsVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  const handleFolderClick = (folderId: number) => {
    setIsFolderOpen((prev) => ({ ...prev, [folderId]: !prev[folderId] }));
    setActiveFolder(folderId); // Set the active folder ID

    dispatch(setActiveChat(""));
  };
  // Function to handle folder/chat selection and set active item

  const handleLogout = async () => {
    removeCookieToken("isAuthenticated");
    removeCookieToken("token");
    await dispatch(logoutState()); // Dispatch logout action
    navigate("/login"); // Navigate to login
  };
  const handleDragStart = (e: React.DragEvent, chat: Chat, folderId: number | null) => {
    e.dataTransfer.setData(
      "chat",
      JSON.stringify({
        id: chat.id,
        title: chat.title, // Make sure title is included
        content: chat.messages || chat.title, // Fallback to content or title
        pinned: chat.pinned,
        folderId, // Include folder ID to track the source
      })
    );
    e.dataTransfer.setData("chatId", chat.id.toString());
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.currentTarget.classList.add("drag-over"); // Add a CSS class
  };
  const handleDrop = (e: React.DragEvent, targetFolderId: number | null) => {
    e.preventDefault();

    // Extract the dropped chat data
    const droppedChat = JSON.parse(e.dataTransfer.getData("chat"));
    const chatId1 = parseInt(e.dataTransfer.getData("chatId"), 10);

    const { id: chatId, folderId: sourceFolderId } = droppedChat;

    // ✅ Log source and target folder IDs
    console.log("Chat ID:", chatId1);
    console.log("Dropped into Folder ID:", targetFolderId);
    const getChatResponce = apiService
      .updateChatDestimation({ chat_id: chatId1, folder_id: targetFolderId ?? 0 })
      .then((response) => {
        return JSON.stringify(response.data);
      });
    console.log("getChatResponce", getChatResponce);
    // Prevent dropping into the same folder
    if (targetFolderId === sourceFolderId) return;

    // Remove chat from the source folder
    setFolders((prevFolders) =>
      prevFolders.map((folder) => {
        if (folder.id === sourceFolderId) {
          return {
            ...folder,
            messages: folder.messages.filter((chat) => chat.id !== chatId),
          };
        }
        return folder;
      })
    );

    // Add chat to the target folder if it's not already there
    if (targetFolderId !== null) {
      setFolders((prevFolders) =>
        prevFolders.map((folder) => {
          if (folder.id === targetFolderId) {
            const alreadyExists = folder.messages.some((chat) => chat.id === chatId);
            if (!alreadyExists) {
              return {
                ...folder,
                messages: [...folder.messages, droppedChat],
              };
            }
          }
          return folder;
        })
      );
    }

    // Handle moving between the main chat list and folders
    if (sourceFolderId === null) {
      setChats((prevChats) => prevChats.filter((chat) => chat.id !== chatId));
    }
    if (targetFolderId === null) {
      const alreadyExists = chats.some((chat) => chat.id === chatId);
      if (!alreadyExists) {
        setChats((prevChats) => [...prevChats, droppedChat]);
      }
    }
  };
  useEffect(() => {
    window.innerWidth < 768 && dispatch(toggleMinimize());
  }, []);
  return (
    <Resizable
      defaultSize={{
        width: window.innerWidth > 1024 ? 256 : 320,
        height: "100%",
      }}
      // lockAspectRatioExtraHeight={200}
      maxWidth={window.innerWidth > 1024 ? 500 : 270}
      minWidth={window.innerWidth > 1024 ? 256 : 200}
      minHeight="100vh"
      // maxHeight={`${window.innerWidth > 768 ? "98vh" : "100vh"}`}
      maxHeight={"100vh"}
      className={`transition-all md:duration-0 md:!relative !fixed md:!bg-none md:bg-transparent bg-lightBg dark:bg-gradient-dark ease-in-out ${isMinimized ? "isMinimized !min-w-0 !w-0 opacity-0 translate-x-[-100%] z-0 !duration-300" : "max-w-64 w-full z-[61]"} 
      
      font-ProximaLight dark:text-[#d1d1d1b8] flex  text-[#191919] flex-col`}
    >
      <div className={`font-ProximaLight dark:text-[#d1d1d1b8] flex flex-col h-full`}>
        {/* Logo and Title */}

        <div className="flex items-center px-3 py-4">
          <img src={logo} alt="logo" className="w-6 h-6 lg:w-8 lg:h-8" />
          {!isMinimized && (
            <h2 className="ml-3 text-sm font-bold lg:text-xl duration-0 dark:text-white font-Halcom whitespace-nowrap">
              Vellum GPT
            </h2>
          )}
        </div>

        {/* Control Buttons */}
        <div className="flex justify-between py-5 pl-2 pr-1">
          <div className="flex space-x-0">
            {sidetoolbarButtons.map(({ id, icon, onClick, alt }) => (
              <span key={id}>
                <Tooltip
                  content={alt}
                  placement="top-start"
                  classNames={{
                    content: [
                      "bg-transparent capitalize transition-all ease backdrop-blur-[23px] brightness-125 dark:brightness-150 rounded-lg shadow-none",
                    ],
                  }}
                >
                  <Button
                    onPress={onClick}
                    className="min-w-0 p-2 bg-transparent hover:text-gray-400 group"
                  >
                    <img
                      src={icon}
                      alt={alt}
                      width={20}
                      className="dark:brightness-[1.75] dark:group-hover:brightness-100 group-hover:brightness-[0] transition-all duration-300"
                    />
                  </Button>
                </Tooltip>
              </span>
            ))}
          </div>
          <Tooltip
            content="Close Sidebar"
            placement="top-start"
            classNames={{
              content: [
                "bg-transparent capitalize transition-all ease backdrop-blur-[23px] brightness-125 dark:brightness-150 rounded-lg shadow-none",
              ],
            }}
          >
            <Button onPress={toggleSidebar} className="min-w-0 p-2 bg-transparent">
              <img
                src={
                  isMinimized
                    ? isDarkMode
                      ? openSidebar
                      : openSidebarLight
                    : isDarkMode
                      ? closeSidebar
                      : closeSidebarLight
                }
                alt="toggle sidebar"
                width={20}
                className="dark:brightness-[1.75] dark:hover:brightness-100 hover:brightness-[0] transition-all duration-300 "
              />
            </Button>
          </Tooltip>
        </div>
        {/* Folder option */}

        <span className="px-4 mb-1 mt-3 text-xs md:text-sm text-[#7B7B7B]">Folders</span>
        {isLoading ? (
          <SidebarSkeleton />
        ) : (
          <div className="flex flex-col h-full max-h-[25vh] overflow-y-auto grow">
            {folders.map((folder) => {
              return (
                <div
                  key={folder.id}
                  onDrop={(e) => handleDrop(e, folder.id)} // Drop to a specific folder
                  className="mb-1 group closeRef"
                >
                  <div // Drag folder
                    className={`flex justify-between items-center w-full hover:bg-white dark:hover:bg-[#192c3a] rounded-lg ${activeItem === folder.id ? "dark:bg-[#192c3a]" : ""}`}
                    onDragOver={handleDragOver}
                    onDrop={(e) => handleDrop(e, folder.id)}
                  >
                    <Button
                      className="cursor-pointer h-auto min-w-0 flex items-center justify-start bg-transparent !outline-none px-4 w-full py-2 font-light rounded-lg text-sm hover:bg-white dark:hover:bg-[#192c3a]"
                      onPressStart={() => {
                        handleFolderClick(folder.id);
                        handleFolderSelect(folder);
                      }}
                    >
                      <img
                        src={chatArrowIcon}
                        alt="arrow"
                        className={`mr-3 transform transition-all duration-400 ${theme === "dark" ? "" : "filterGrey"} ${isFolderOpen[folder.id] ? "rotate-0" : "rotate-180"}`}
                      />
                      <span className="line-clamp-1 text-ellipsis overflow-hidden block text-left dark:text-[#D1D1D1] text-[#191919]">
                        {folder.title}
                      </span>
                    </Button>
                    {folder.pinned ? (
                      <div className="flex items-center justify-center min-w-3">
                        <Tooltip
                          content="Unpin Folder"
                          classNames={{
                            content: [
                              "dark:bg-[#265376]/30 bg-white backdrop-blur-[23px] rounded-lg shadow-none",
                            ],
                          }}
                        >
                          {/* <img src={pinIcon} alt="Unpin Chat" width={13} /> */}
                          <div className="dark:text-[#F2E900] text-[#F2BA00]">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              id="Group_17439"
                              data-name="Group 17439"
                              width="14"
                              height="14"
                              viewBox="0 0 26.624 26.623"
                            >
                              <defs>
                                <clipPath id="clip-path">
                                  <rect
                                    id="Rectangle_16755"
                                    data-name="Rectangle 16755"
                                    width="26.624"
                                    height="26.623"
                                    fill="currentColor"
                                  />
                                </clipPath>
                              </defs>
                              <g
                                id="Group_17435"
                                data-name="Group 17435"
                                clipPath="url(#clip-path)"
                              >
                                <path
                                  id="Path_41601"
                                  data-name="Path 41601"
                                  d="M16.769,2.486c-.234-.221-.472-.435-.7-.661A1.041,1.041,0,1,1,17.54.354q4.367,4.363,8.73,8.73A1.042,1.042,0,1,1,24.8,10.551c-.227-.224-.444-.459-.7-.725a2.284,2.284,0,0,1-.168.222q-2.571,2.575-5.148,5.144a.493.493,0,0,0-.155.479,9.226,9.226,0,0,1-2.5,8.053,1.047,1.047,0,0,1-1.673.018L9.623,18.909c-.066-.066-.136-.129-.215-.205-.077.073-.147.135-.213.2q-3.658,3.657-7.314,7.316a1.082,1.082,0,0,1-1.1.367,1.033,1.033,0,0,1-.553-1.655,2.933,2.933,0,0,1,.232-.245q3.62-3.621,7.242-7.241c.067-.067.147-.122.242-.2-.09-.1-.151-.164-.216-.229L2.9,12.183a1.048,1.048,0,0,1,0-1.691A9.243,9.243,0,0,1,10.981,8a.4.4,0,0,0,.4-.1q2.63-2.645,5.271-5.278c.03-.03.058-.064.12-.133"
                                  transform="translate(0.001 0)"
                                  fill="currentColor"
                                />
                              </g>
                            </svg>
                          </div>
                        </Tooltip>
                      </div>
                    ) : null}
                    <button
                      className={`dark:text-[#265376] text-[#7B7B7B] rounded-full relative py-1 ${theme === "dark" ? "" : "filterGrey"}`}
                      onClick={(event) => handleDotFolderClick(folder.id, event)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M11 12a1 1 0 1 0 2 0a1 1 0 1 0-2 0m0 7a1 1 0 1 0 2 0a1 1 0 1 0-2 0m0-14a1 1 0 1 0 2 0a1 1 0 1 0-2 0"
                        />
                      </svg>
                    </button>
                    {/* <>
                      {console.log('folders:',folders,'activeFolder',activeFolder,', folder.id',folder.id,', isOptionsVisible',isOptionsVisible,', optionsPosition',optionsPosition,', insideChats: ',folder.messages.length > 0 ? true : false)}                
                    </> */}
                    {activeFolder === folder.id && isOptionsFolderVisible && (
                      <OptionsMenu
                        IsMessageLength={folder.messages.length > 0}
                        position={optionsPosition}
                        chatId={folder.id}
                        name={folder.title}
                        pin={folder.pinned}
                        type="folder"
                        toggleOptions={setIsOptionsFolderVisible}
                      />
                    )}
                  </div>

                  {/* Folder content */}
                  {isFolderOpen[folder.id] && (
                    <ul className="flex flex-col overflow-y-auto max-h-[33vh] space-y-1">
                      {folder.messages.map((chat: any) => (
                        <li
                          key={chat.id}
                          draggable
                          onDragStart={(e) => handleDragStart(e, chat, folder.id ?? null)}
                          className="flex closeRef h-fit items-center w-full min-w-0 bg-transparent justify-start hover:bg-white dark:hover:bg-[#192c3a] cursor-pointer rounded-sm outline-none"
                        >
                          <div
                            onDragStart={(e) => handleDragStart(e, chat, folder.id)}
                            className={`pl-3 ${activeItem === chat.id ? "dark:bg-[#192c3a]" : ""} custom_button font-light rounded-lg text-sm md:text-base flex justify-between`}
                          >
                            <Button
                              draggable
                              onPress={() => handleChatSelect(chat)}
                              className="pl-12 py-1.5 text-left h-auto items-center w-full min-w-0 bg-transparent justify-start hover:bg-white dark:hover:bg-[#192c3a] cursor-pointer rounded-sm outline-none block overflow-hidden text-ellipsis"
                            >
                              {chat.content}
                            </Button>
                            <button
                              className="text-[#265376] relative px-1 flex flex-row-reverse items-center"
                              onClick={(event) => handleDotChatClick(chat.id, event)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="none"
                                  stroke="currentColor"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M11 12a1 1 0 1 0 2 0a1 1 0 1 0-2 0m0 7a1 1 0 1 0 2 0a1 1 0 1 0-2 0m0-14a1 1 0 1 0 2 0a1 1 0 1 0-2 0"
                                />
                              </svg>

                              <div className="flex items-center justify-center">
                                {chat.pinned ? (
                                  <Tooltip
                                    content="Unpin Chat"
                                    classNames={{
                                      content: [
                                        "dark:bg-[#265376]/30 bg-white backdrop-blur-[23px] rounded-lg shadow-none",
                                      ],
                                    }}
                                  >
                                    {/* <img src={pinIcon} alt="Unpin Chat" width={13} /> */}
                                    <div className="dark:text-[#F2E900] text-[#F2BA00]">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        id="Group_17439"
                                        data-name="Group 17439"
                                        width="14"
                                        height="14"
                                        viewBox="0 0 26.624 26.623"
                                      >
                                        <defs>
                                          <clipPath id="clip-path">
                                            <rect
                                              id="Rectangle_16755"
                                              data-name="Rectangle 16755"
                                              width="26.624"
                                              height="26.623"
                                              fill="currentColor"
                                            />
                                          </clipPath>
                                        </defs>
                                        <g
                                          id="Group_17435"
                                          data-name="Group 17435"
                                          clipPath="url(#clip-path)"
                                        >
                                          <path
                                            id="Path_41601"
                                            data-name="Path 41601"
                                            d="M16.769,2.486c-.234-.221-.472-.435-.7-.661A1.041,1.041,0,1,1,17.54.354q4.367,4.363,8.73,8.73A1.042,1.042,0,1,1,24.8,10.551c-.227-.224-.444-.459-.7-.725a2.284,2.284,0,0,1-.168.222q-2.571,2.575-5.148,5.144a.493.493,0,0,0-.155.479,9.226,9.226,0,0,1-2.5,8.053,1.047,1.047,0,0,1-1.673.018L9.623,18.909c-.066-.066-.136-.129-.215-.205-.077.073-.147.135-.213.2q-3.658,3.657-7.314,7.316a1.082,1.082,0,0,1-1.1.367,1.033,1.033,0,0,1-.553-1.655,2.933,2.933,0,0,1,.232-.245q3.62-3.621,7.242-7.241c.067-.067.147-.122.242-.2-.09-.1-.151-.164-.216-.229L2.9,12.183a1.048,1.048,0,0,1,0-1.691A9.243,9.243,0,0,1,10.981,8a.4.4,0,0,0,.4-.1q2.63-2.645,5.271-5.278c.03-.03.058-.064.12-.133"
                                            transform="translate(0.001 0)"
                                            fill="currentColor"
                                          />
                                        </g>
                                      </svg>
                                    </div>
                                  </Tooltip>
                                ) : null}
                              </div>
                            </button>
                          </div>

                          {selectedChatId === chat.id && isOptionsVisible && (
                            <OptionsMenu
                              position={optionsPosition}
                              chatId={chat.id}
                              pin={chat.pinned}
                              name={chat.content}
                              type="chat"
                              toggleOptions={setIsOptionsVisible}
                            />
                          )}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              );
            }
            )}
          </div>
        )}
        {isLoading ? (
          <></>
        ) : (
          <div
            className="flex flex-col space-y-1 overflow-y-auto h-[48vh]"
            onDragOver={handleDragOver}
            onDrop={(e) => handleDrop(e, null)}
          >
            {/* Chat Items */}
            {chats?.length > 0 ? (
              <span className="chat-item px-4 mb-1 pt-3 mt-2 text-xs md:text-sm border-t-[0.1px] border-t-[#7b7b7b63] text-[#7B7B7B]">
                Today
              </span>
            ) : null}
            <ul
              className="flex flex-col space-y-1 overflow-y-auto grow "
              onDragOver={handleDragOver}
              onDrop={(e) => handleDrop(e, null)}
            >
              {chats.map((chat) => (
                <li
                  key={chat.id}
                  draggable
                  onDragStart={(e) => handleDragStart(e, chat, null)}
                  className={`pl-3 py-0 ${activeItem === chat.id ? "dark:bg-[#192c3a] bg-white" : ""}
            font-light rounded-lg text-sm md:text-base hover:bg-white dark:hover:bg-[#192c3a] transition-background ease-in-out duration-200 cursor-pointer flex justify-between chat-item`}
                >
                  <div
                    className="custom_button font-light dark:text-[#D1D1D1] text-[#191919] rounded-lg text-sm 2xl:text-base cursor-pointer flex justify-between items-center"
                  // style={{ wordBreak: "break-word" }}
                  >
                    <Button
                      draggable
                      onPress={() => handleChatSelect(chat)}
                      className="w-[85%] closeRef bg-transparent overflow-hidden text-ellipsis line-clamp-1 text-left whitespace-nowrap block pl-1.5"
                    >
                      {chat.title}
                    </Button>

                    <span
                      className="dark:text-[#265376] text-[#7B7B7B] relative py-2 flex flex-row-reverse items-center"
                      onClick={(e) => handleDotChatClick(chat.id, e)} // MouseEvent
                      role="button"
                      tabIndex={0} // Make the element focusable
                      onKeyDown={(e) => handleDotChatClick(chat.id, e)} // KeyboardEvent
                      aria-label="More options"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M11 12a1 1 0 1 0 2 0a1 1 0 1 0-2 0m0 7a1 1 0 1 0 2 0a1 1 0 1 0-2 0m0-14a1 1 0 1 0 2 0a1 1 0 1 0-2 0"
                        />
                      </svg>

                      <div className="flex items-center justify-center">
                        {chat.pinned ? (
                          <Tooltip
                            content="Unpin Chat"
                            classNames={{
                              content: [
                                "dark:bg-[#265376]/30 bg-white backdrop-blur-[23px] rounded-lg shadow-none",
                              ],
                            }}
                          >
                            {/* <img src={pinIcon} alt="Unpin Chat" width={13} /> */}
                            <div className="dark:text-[#F2E900] text-[#F2BA00]">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                id="Group_17439"
                                data-name="Group 17439"
                                width="14"
                                height="14"
                                viewBox="0 0 26.624 26.623"
                              >
                                <defs>
                                  <clipPath id="clip-path">
                                    <rect
                                      id="Rectangle_16755"
                                      data-name="Rectangle 16755"
                                      width="26.624"
                                      height="26.623"
                                      fill="currentColor"
                                    />
                                  </clipPath>
                                </defs>
                                <g
                                  id="Group_17435"
                                  data-name="Group 17435"
                                  clipPath="url(#clip-path)"
                                >
                                  <path
                                    id="Path_41601"
                                    data-name="Path 41601"
                                    d="M16.769,2.486c-.234-.221-.472-.435-.7-.661A1.041,1.041,0,1,1,17.54.354q4.367,4.363,8.73,8.73A1.042,1.042,0,1,1,24.8,10.551c-.227-.224-.444-.459-.7-.725a2.284,2.284,0,0,1-.168.222q-2.571,2.575-5.148,5.144a.493.493,0,0,0-.155.479,9.226,9.226,0,0,1-2.5,8.053,1.047,1.047,0,0,1-1.673.018L9.623,18.909c-.066-.066-.136-.129-.215-.205-.077.073-.147.135-.213.2q-3.658,3.657-7.314,7.316a1.082,1.082,0,0,1-1.1.367,1.033,1.033,0,0,1-.553-1.655,2.933,2.933,0,0,1,.232-.245q3.62-3.621,7.242-7.241c.067-.067.147-.122.242-.2-.09-.1-.151-.164-.216-.229L2.9,12.183a1.048,1.048,0,0,1,0-1.691A9.243,9.243,0,0,1,10.981,8a.4.4,0,0,0,.4-.1q2.63-2.645,5.271-5.278c.03-.03.058-.064.12-.133"
                                    transform="translate(0.001 0)"
                                    fill="currentColor"
                                  />
                                </g>
                              </svg>
                            </div>
                          </Tooltip>
                        ) : null}
                      </div>
                    </span>
                    {selectedChatId === chat.id && isOptionsVisible && (
                      <OptionsMenu
                        type="chat"
                        position={optionsPosition}
                        pin={chat.pinned}
                        name={chat.title}
                        chatId={chat.id}
                        toggleOptions={setIsOptionsVisible} // Pass the function to toggle visibility
                      />
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Profile Section */}
        <Popover
          classNames={{
            content: ["bg-white dark:bg-[#1F1F1F] items-start rounded-[7px]"],
            base: ["rounded-[7px]"],
          }}
          offset={10}
          backdrop="transparent"
          placement="top-start"
        >
          <PopoverTrigger>
            <Button className="flex flex-none min-h-0 h-auto !rounded-0 items-center md:m-0 m-3 md:p-4 p-1 bg-transparent text-left justify-start">
              <img
                src={userChatIcon}
                className="rounded-full"
                width={33}
                height={33}
                alt="user"
              />
              {!isMinimized && (
                <span className="ml-2 text-base font-halcomRegular text-[#191919] dark:text-white">
                  {userData?.name}
                </span>
              )}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-[240px] !bg-transparent backdrop-blur-[20px] dark:brightness-[0.8] brightness-90">
            <Button
              className="text-sm justify-start bg-transparent !rounded-0 font-ProximaLight w-full"
              onPress={handleLogout}
            >
              Log out
            </Button>
          </PopoverContent>
        </Popover>
      </div>
    </Resizable>
  );
};

export default Sidebar;
